import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/warehouse-categories`)
  return data.data
}

export const useWarehouseCategories = () => {
  const { data, ...props } = useQuery(
    queryKeys.WAREHOUSE_CATEGORIES,
    () => getData(),
  )
  return { data, ...props }
}
